import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import Slider from "@react-native-community/slider";

type Props = {
	maxValue: number;
	handleChange: (value: number) => void;
	value: number;
	step: number;
	minValue?: number;
	disabled?: boolean;
	testID?: string;
};

const CustomSlider = ({
	maxValue,
	handleChange,
	value,
	step,
	disabled,
	minValue = 0,
	testID = "custom-slider",
}: Props) => {
	const theme = useAppTheme();

	return (
		<Slider
			// @ts-expect-error web-only style
			style={{ flex: 1, ...(isWeb ? { cursor: "grab" } : {}) }}
			minimumValue={minValue}
			thumbTintColor={theme.colors.primary}
			minimumTrackTintColor={theme.colors.primary}
			maximumValue={maxValue}
			onSlidingComplete={handleChange}
			step={step}
			aria-label={`Slider with value ${value}`}
			tapToSeek
			disabled={disabled}
			value={value}
			testID={testID}
		/>
	);
};

export default CustomSlider;
